import { StatusCodes } from 'http-status-codes'

export const HttpStatusCodes = StatusCodes
